import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '120px 40px',
        background: '#FDF9F3',
        borderRadius: 16,
        gap: 32
    },
    title: {
        fontWeight: 700,
        fontSize: 24,
        lineHeight: '120%',
        color: '#282D31',
        textAlign: 'center'
    },
    button: {
        color: '#FFFFFF',
        background: '#FF7143',
        borderRadius: 16,
        padding: '20px 40px',
        textDecoration: 'none !important',
        boxShadow: 'none !important',
        transition: 'all 0.3s',
        '&:hover': {
            background: '#FF7143',
            opacity: 0.85
        },
        '&:active': {
            opacity: 1,
            background: '#F1683B'
        }
    },
    icon: {
        width: 12,
        height: 12,
        padding: 2,
        background: '#fff',
        color: '#F26A6C',
        marginRight: 8,
        borderRadius: '50%'
    }
});
